// extracted by mini-css-extract-plugin
export default {"wrapper":"xu-z","button":"yu-z","alternate":"zu-z","disabled":"Au-z","paymentWarning":"Bu-z","fadeIn":"Cu-z"};